import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Deal_1 from '../../../assets/images/home_page_7/deals/01.png';
import Deal_2 from '../../../assets/images/home_page_7/deals/02.png';
import Deal_3 from '../../../assets/images/home_page_7/deals/03.png';
import Deal_4 from '../../../assets/images/home_page_7/deals/04.png';
import Deal_5 from '../../../assets/images/home_page_7/deals/05.png';
import Deal_6 from '../../../assets/images/home_page_7/deals/06.png';
import Deal_7 from '../../../assets/images/home_page_7/deals/07.png';
import Deal_8 from '../../../assets/images/home_page_7/deals/08.png';

const dealsData = {
    "Latest Products": [
        {
            id: 1,
            image: Deal_1,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 2,
            image: Deal_2,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 3,
            image: Deal_3,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 4,
            image: Deal_4,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 5,
            image: Deal_5,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 6,
            image: Deal_6,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 7,
            image: Deal_7,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 8,
            image: Deal_8,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        
    ],
    "Top Rating": [
        {
            id: 5,
            image: Deal_5,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 6,
            image: Deal_6,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 7,
            image: Deal_7,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 8,
            image: Deal_8,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
    ],
    "Best Selling": [
        {
            id: 9,
            image: Deal_1,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 10,
            image: Deal_2,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 11,
            image: Deal_3,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 12,
            image: Deal_4,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
    ],
};

const Deal = () => {
    const [activeTab, setActiveTab] = useState('Latest Products');

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    return (
        <section id="deals-product-seven" className="deals-product-seven-main-block">
            <div className="container">
                <div className="deals-product-seven-border">
                    <div className="row">
                        <div className="col-lg-4 col-md-5">
                            <div className="section">
                                <h4 className="deals-section-heading-seven">Deals Of The Day</h4>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-7">
                            <ul className="nav nav-pills float-lg-end float-start" id="pills-tab" role="tablist">
                                {Object.keys(dealsData).map((tab) => (
                                    <li className="nav-item" role="presentation" key={tab}>
                                        <Link
                                            className={`nav-link ${activeTab === tab ? "active" : ""}`}
                                            onClick={() => handleTabChange(tab)}
                                            id={`pills-tab${tab}-tab`}
                                            data-bs-toggle="pill"
                                            to={`#pills-tab${tab}`}
                                            role="tab"
                                            aria-controls={`pills-tab${tab}`}
                                            aria-selected={activeTab === tab}
                                        >
                                            {tab}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="tab-content" id="pills-tabContent">
                        {Object.keys(dealsData).map((tab) => (
                            <div
                                key={tab}
                                className={`tab-pane fade ${activeTab === tab ? 'show active' : ''}`}
                                id={`pills-tab${tab}`}
                                role="tabpanel"
                                aria-labelledby={`pills-tab${tab}-tab`}
                            >
                                <div className="row">
                                    {dealsData[tab].map(deal => (
                                        <div key={deal.id} className="col-lg-3 col-md-6">
                                            <div className="deals-day-seven-block">
                                                <div className="deals-day-seven-img">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={deal.image}
                                                            className="img-fluid"
                                                            alt={deal.title}
                                                        />
                                                    </Link>
                                                    <span className="badge text-bg-primary">{deal.price}</span>
                                                </div>
                                                <div className="deals-day-seven-dtl">
                                                    <h6 className="day-seven-heading">
                                                        <Link to="/ShopDetails" title="">
                                                            {deal.title}
                                                        </Link>
                                                    </h6>
                                                    <p className="day-seven-about">
                                                        By <span>{deal.seller}</span> in <span>{deal.category}</span>
                                                    </p>
                                                    <div className="deals-day-seven-sale-icon">
                                                        <Link to="#" title="">
                                                            <i className="flaticon-shopping-cart" /> {deal.sales} Sale
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Deal;